<template>
  <section class="app-ecommerce-details ">

    <!-- <b-row class="pb-2 d-flex justify-content-end mr-1">
        <b-col cols="auto" class="text-right align-self-end">
          <p><strong>Total de Pedidos :</strong> {{ totalUnidades }}</p>
          <p><strong>Total Valor : </strong> R$ {{ totalValor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
        </b-col>
      </b-row> -->
    <div v-if="getIsLoadingReferencia" class="loading-indicator">
      <b-spinner small type="grow" class="mr-2"></b-spinner>
      Carregando referências...
    </div>
    <div v-if="getIsLoadingReferenciaRestante" class="loading-indicator">
      <b-spinner small type="grow" class="mr-2"></b-spinner>
      Carregando mais itens...
    </div>
    <!-- LISTAGEM SIMPLES EM LINHAS: thumb pequena + nome/código + preço +
         estoque + quantidade + Adicionar. A listagem antiga (galeria de fotos,
         ficha técnica, fluxo "Selecionar") foi substituída por decisão de
         produto — o fluxo é: filtrar, achar a linha, digitar a quantidade e
         clicar em Adicionar. -->
    <div class="lista-itens-simples">
      <div
        v-for="product in visibleProducts"
        :key="product.item_id || product.itemId || product.CodItem"
        class="linha-item d-flex align-items-center"
      >
        <!-- Foto principal (pequena, no canto) -->
        <div class="linha-thumb flex-shrink-0">
          <b-img
            :src="product.item_img_princial ? product.item_img_princial : imagemPadrao"
            :alt="`${product.item_descricao || product.itemDescricao || product.item_name}-${product.item_id || product.itemId}`"
          />
        </div>

        <!-- Nome / código / marca -->
        <div class="linha-info flex-grow-1 mx-1">
          <div class="linha-nome">
            {{ product.item_id || product.itemId || product.CodItem }}
            - {{ product.item_descricao || product.itemDescricao || product.item_name || product.Descricao }}
          </div>
          <div class="linha-meta text-muted">
            <span>{{ product.item_id || product.itemId || product.CodItem }}</span>
            <span v-if="product.item_marca"> · {{ product.item_marca }}</span>
          </div>
          <pic-oferta-inline v-if="$store.getters['preferencias/picAtivo'] === true && product._detalheCarregado" :item="product"
            :context="pedidoContext" @use-pic="usarPic" />
          <div class="linha-meta">
            <span v-if="product._detalheCarregado" class="linha-preco">
              {{ rotuloPreco(product) }}: {{ dinheiroVisual(precoUnitarioVisual(product)) }}
            </span>
            <b-spinner v-else small class="mr-25" style="width: 0.9rem; height: 0.9rem;" />
            <template v-if="!isPerfilClienteAtivo() && !ocultarEstoque && product._detalheCarregado && produtoDisponivel(product)">
              <b-badge
                v-if="controleEstoqueAtivo && temEstoqueInfo(product)"
                :variant="`light-${estoqueLabel(product).variant}`"
                class="ml-50"
              >
                {{ estoqueLabel(product).label }}
              </b-badge>
              <b-badge v-else variant="light-success" class="ml-50">Em estoque</b-badge>
            </template>
            <b-badge
              v-if="!isPerfilClienteAtivo() && !ocultarEstoque && product._detalheCarregado && !produtoDisponivel(product)"
              variant="light-danger"
              class="ml-50"
            >
              Indisponível
            </b-badge>
            <!-- Quantidade já adicionada desta referência -->
            <div
              v-for="(item, index) in getFilteredItems(product.item_id || product.itemId || product.CodItem)"
              :key="item.uniqueId || index"
              class="qtd-control ml-50"
            >
              <span class="qtd-control-label">No pedido</span>
              <button
                type="button"
                class="qtd-btn qtd-btn-menos"
                title="Diminuir quantidade"
                :disabled="calculationLineId !== null"
                @click="alterarQtdChip(item, -1)"
              >
                <feather-icon icon="MinusIcon" size="16" />
              </button>
              <span class="qtd-valor">{{ item.valor }}</span>
              <button
                type="button"
                class="qtd-btn qtd-btn-mais"
                title="Aumentar quantidade"
                :disabled="calculationLineId !== null"
                @click="alterarQtdChip(item, 1)"
              >
                <feather-icon icon="PlusIcon" size="16" />
              </button>
              <button
                type="button"
                class="qtd-btn qtd-btn-remover"
                title="Remover do pedido"
                @click="removeItem(index, item)"
              >
                <feather-icon icon="Trash2Icon" size="15" />
              </button>
            </div>
          </div>
        </div>

        <!-- Quantidade + Adicionar -->
        <div class="linha-acao d-flex align-items-center flex-shrink-0">
          <b-form-input
            v-model="qtdPorLinha[product.item_id || product.itemId || product.CodItem]"
            type="number"
            min="1"
            placeholder="Qtd."
            class="linha-qtd mr-50"
            :disabled="product._detalheCarregado && !produtoDisponivel(product)"
            @keyup.enter="adicionarLinha(product)"
          />
          <b-button
            variant="primary"
            size="sm"
            :disabled="adicionandoLinhaId === (product.item_id || product.itemId || product.CodItem) || (product._detalheCarregado && !produtoDisponivel(product))"
            @click="adicionarLinha(product)"
          >
            <b-spinner v-if="adicionandoLinhaId === (product.item_id || product.itemId || product.CodItem)" small class="mr-25" />
            <feather-icon v-else icon="PlusIcon" size="14" class="mr-25" />
            Adicionar
          </b-button>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import precoVisualizacaoMixin from './precoVisualizacao.mixin';
import {
  BCard, BCardBody, BRow, BCol, BImg, BCardText, BLink, BButton, BDropdown, BDropdownItem, BAlert, BFormGroup, BFormSpinbutton, BBadge, BInputGroup, BInputGroupAppend, BFormInput, BSpinner,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { ref } from '@vue/composition-api';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue';
import Swal from 'sweetalert2';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';
import { isPerfilClienteAtivo, isPerfilRepresentanteAtivo, nomeCategoria } from '@/libs/perfilCliente';
import axios from '@/libs/axios';
import SLSAdocaoClient from '@/api/Operacoes/sls-adocao.client';
import SLSEstoqueService from '@/services/SistemaDKP/SLSEstoque.service';
import { ocultarEstoqueCertificacao, tipoPedidoSelecionadoParaEstoque } from '@/utils/estoqueVisibilidade';
import ItemFichaTecnica from '@/components/ItemFichaTecnica.vue';

export default {
  mixins: [precoVisualizacaoMixin],
  directives: {
    Ripple,
  },
  components: {
    ItemFichaTecnica,
    ScrollToTop,
    BCard,
    SwiperSlide,
    Swiper,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BAlert,
    BFormGroup,
    BFormSpinbutton,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BSpinner,
    // Lazy registration keeps the order screen's initial bundle small and
    // avoids loading PIC UI for tenants where PIC is disabled.
    PicOfertaInline: () => import('@/components/catalogo-produtos/PicOfertaInline.vue'),
  },
  props: {
    tipoPedidoPrecoVisual: {
      type: String,
      default: null,
    },
    cotacoesPrecoVisuais: {
      type: Object,
      default: () => ({}),
    },
    // A capa persistida do pedido existente precede seleções antigas da Home.
    tipoPedidoId: {
      type: String,
      default: null,
    },
    // Hook opcional executado depois das validações/estoque e antes de alterar
    // a grade local. O pai usa-o para calcular o preço; retorno nulo bloqueia
    // o "Adicionar", evitando que o próprio commit seja o gatilho do cálculo.
    beforeAddItem: {
      type: Function,
      default: null,
    },
    // Pais que implementam a política WS/WC antes do cálculo marcam este
    // contrato. Demais consumidores preservam a validação legada deste filho.
    managesClientCategory: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      imagemPadrao: IMAGEM_PADRAO,
      showColorSizeOptions: false,
      formColor: {
        embalagem: '',
        cdn_embalagem: '',
        color: '',
        tamanho: '',
        quantidade: 0,
      },
      items: [],
      availableColors: [],
      availableSizes: [],
      isLoading: true,
      adocaoData: null,
      isLoadingAdocao: false,
      isApplyingAdocao: false,
      autoAplicarAdocao: (typeof localStorage !== 'undefined' && localStorage.getItem('carrinhoInteligente.autoAplicar') === '1'),
      temporadaSelecionada: (typeof localStorage !== 'undefined' && localStorage.getItem('carrinhoInteligente.temporada')) || '',
      adocaoAutoAppliedKey: null,
      adocaoAutoAppliedTry: null,
      temporadasOptions: [
        { value: '', text: 'Geral (qualquer época)' },
        { value: 'volta_as_aulas', text: 'Volta às Aulas' },
        { value: 'natal', text: 'Natal' },
        { value: 'dia_das_maes', text: 'Dia das Mães' },
        { value: 'dia_dos_pais', text: 'Dia dos Pais' },
        { value: 'pascoa', text: 'Páscoa' },
        { value: 'black_friday', text: 'Black Friday' },
        { value: 'inverno', text: 'Inverno' },
        { value: 'verao', text: 'Verão' },
      ],
      itemSelected: [{
        imagens: [],
      }],
      // Estoque por produto (item_id -> { quantidade, fonte, ... }), usado para
      // exibir o saldo e bloquear venda sem estoque (mesma regra da home).
      estoqueMap: {},
      // Quantidade digitada em cada LINHA da listagem simples (item_id shell -> qtd)
      qtdPorLinha: {},
      // item_id da linha cujo "Adicionar" está em processamento (spinner/disable)
      adicionandoLinhaId: null,
      // Identidade do chip cuja nova quantidade aguarda cálculo do pai.
      calculationLineId: null,
      visibleCount: 3,
      swiperOptions: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },

    };
  },
  computed: {
    ocultarEstoque() {
      const form = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
      return ocultarEstoqueCertificacao(this.tipoPedidoId
        || form.tipoPedido?.tipopedidoid
        || tipoPedidoSelecionadoParaEstoque(this.$store));
    },
    ...mapGetters({
      json: 'intensPedido/getjsonTelaNovaPedido',
    }),
    ...mapGetters('intensPedido', [
      'getIsLoadingReferencia',
      'getIsLoadingReferenciaRestante',

    ]),
    ...mapGetters('preferencias', [
      'controleEstoqueAtivo',
      'bloquearVendaSemEstoque',
    ]),
    visibleProducts() {
      return this.json;
      // return this.json.slice(0, this.visibleCount);
    },
    temporadaLabel() {
      const opt = this.temporadasOptions.find((o) => o.value === this.temporadaSelecionada);
      return opt ? opt.text : '';
    },
    hasMoreProducts() {
      // console.log(this.json.length, this.visibleCount)
      // return this.json.length > this.visibleCount;
      return false;
    },
    pedidoContext() {
      return this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
    },
  },
  watch: {
    // Carrega o estoque de todos os produtos cujo detalhe já foi carregado —
    // mostra o número do saldo (como no catálogo) já na listagem/busca, sem
    // depender do clique em "Selecionar".
    json: {
      immediate: true,
      deep: true,
      handler() {
        (this.json || []).forEach((product) => {
          const id = product.item_id || product.itemId || product.CodItem;
          if (id && this.qtdPorLinha[id] === undefined) this.$set(this.qtdPorLinha, id, 1);
        });
        this.carregarEstoqueLista();
      },
    },
  },
  mounted() {
    this.items = [];
    this.$root.$on('modal:opened', this.resetItems);
    this.$root.$on('item:removed', this.handleItemRemoved);
    this.$root.$on('subitem:removed', this.handleSubItemRemoved);

    this.$root.$on('modal:sync-items', this.syncWithStore);
  },
  beforeDestroy() {
    this.$store.dispatch('intensPedido/setIsLoadingReferenciaRestante', false);
    this.$root.$off('modal:opened');
    this.$root.$off('item:removed');
    this.$root.$off('subitem:removed');
    this.$root.$off('modal:sync-items');
  },
  methods: {
    isPerfilClienteAtivo,
    usarPic(offer) {
      const form = this.pedidoContext || {};
      this.$root.$emit('openModal:pic', {
        type: 'operacao-pedido',
        operacao: 'create',
        data: {
          estabelecimento: {
            estabelecimentoid: form.estabelecimento?.estabelecimentoid,
            ufid: form.estabelecimento?.ufid,
          },
          cliente: {
            clienteid: form.cliente?.clienteid,
            clientenomeabreviado: form.cliente?.clientenomeabreviado,
            clientenatoperinterna: form.cliente?.clientenatoperinterna,
            clientenatoperexterna: form.cliente?.clientenatoperexterna,
          },
          naturezaOperacao: {
            naturezaoperacaoid: form.naturezaOperacao?.naturezaoperacaoid,
          },
          canalVenda: {
            canal_venda_id: form.cliente?.canal_venda_id,
          },
          enderecoEntrega: form.enderecoEntrega || {},
          clienteisentoie: form.cliente?.clienteisentoie,
          tabelaprecoid: form.tabelaPreco?.tabelapreco_id,
          condicaopagamentoid: form.condicaoPagamento?.condicaopagamentoid,
        },
        itemid: offer.itemid,
        picid: offer.picid,
      });
    },
    precoExibicao(product) {
      const preco = Number(product?.item_price);
      return Number.isFinite(preco) && preco > 0
        ? preco.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : 'aguardando cálculo';
    },
    rotuloPreco(product) {
      return this.valorDeCustoVisual ? 'Valor de custo' : 'Valor';
    },
    hasValidEmbalagens(product) {
      return this.getValidEmbalagens(product?.embalagens || []).length > 0;
    },
    normalizarSkuId(value) {
      const normalized = String(value ?? '').trim();
      return normalized;
    },
    skuResolvidoDe(product) {
      if (!product) return '';
      return this.normalizarSkuId(product.itemIdUnico)
        || this.normalizarSkuId(product.item_id)
        || this.normalizarSkuId(product.itemId)
        || this.normalizarSkuId(product.CodItem);
    },
    // Embalagem é opcional para produtos de SKU único (ex.: livros), mas um
    // produto carregado só pode ser adicionado quando o detalhe resolveu um
    // SKU real.
    produtoDisponivel(product) {
      return !!this.skuResolvidoDe(product);
    },
    getValidEmbalagens(embalagens) {
      return (embalagens || []).filter((embalagem) => !!embalagem?.cdn_embalagem);
    },
    deveBloquearPorEstoque() {
      // Cliente pode fazer backorder. Representante nunca pode vender sem
      // estoque; os demais perfis seguem a preferência do tenant.
      return !isPerfilClienteAtivo()
        && (this.bloquearVendaSemEstoque || isPerfilRepresentanteAtivo());
    },
    async obterEstoqueDoSku(itemId) {
      const sku = this.normalizarSkuId(itemId);
      if (!sku) return null;

      const existente = this.estoqueMap[sku];
      if (
        existente
        && existente.fonte !== 'carregando'
        && existente.quantidade !== null
        && existente.quantidade !== undefined
      ) {
        return existente;
      }

      try {
        const res = await new SLSEstoqueService().consultarEstoque([sku]);
        const info = (res && res[sku]) || { quantidade: null, fonte: 'sem-resposta' };
        this.$set(this.estoqueMap, sku, info);
        return info;
      } catch (e) {
        console.warn('[TelaNovaPedido] Falha ao consultar estoque do SKU:', e);
        const info = { quantidade: null, fonte: 'erro' };
        this.$set(this.estoqueMap, sku, info);
        return info;
      }
    },
    async validarQuantidadeEstoque(itemId, quantidade) {
      const sku = this.normalizarSkuId(itemId);
      if (!sku) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Nao foi possivel identificar a variacao deste produto. Tente selecionar novamente.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return false;
      }
      if (!this.deveBloquearPorEstoque()) return true;

      const info = await this.obterEstoqueDoSku(sku);
      if (!info || info.quantidade === 'INF'
        || info.quantidade === null || info.quantidade === undefined) {
        return true;
      }

      const disponivel = Number(info.quantidade);
      const solicitado = Number(quantidade);
      if (!Number.isFinite(disponivel) || !Number.isFinite(solicitado)
        || solicitado <= disponivel) {
        return true;
      }

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Estoque insuficiente',
          text: `${isPerfilClienteAtivo() || (isPerfilRepresentanteAtivo() && disponivel > 50)
            ? 'Estoque insuficiente.'
            : `Disponível: ${disponivel} un.`} Solicitado: ${solicitado} un. Ajuste a quantidade para prosseguir.`,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
      return false;
    },
    syncWithStore() {
      this.itensTabela = (this.getlistarTabelaItens || []).flatMap((item) => (item.itens || []).map((subitem) => ({
        ...subitem,
        codMarca: item.CodMarca,
        familiaComercialId: item.CodReferencia,
        marca: item.DescricaoMarca,
        descricao_referencia: item.DescricaoReferencia,
        precoUnitario: subitem.precoUnitario,
        precoComImposto: subitem.precoComImposto,
        valorTotal: subitem.valorTotal,
        pedidoItemQuantidade: subitem.pedidoItemQuantidade,
        embalagem: subitem.embalagem,
        cdn_embalagem: subitem.cdn_embalagem,
        des_cor: subitem.des_cor,
        cdn_cor: subitem.cdncor,
        tamanho: subitem.desc_tamanho,
        item_id: subitem.itemId,
        nome: subitem.item_descricao,
        valor: subitem.pedidoItemQuantidade,
      })));
    },
    handleSubItemRemoved(data) {
      this.items = this.items.filter((item) => !(item.referencia === data.referencia
          && item.item_id === data.item_id
          && item.des_cor === data.des_cor
          && item.tamanho === data.tamanho));
    },
    handleItemRemoved(data) {
      this.items = this.items.filter((item) => item.referencia !== data.referencia);
    },
    resetItems() {
      this.items = [];
      this.formColor = {
        embalagem: '',
        cdn_embalagem: '',
        color: '',
        tamanho: '',
        quantidade: 0,
      };
      this.availableColors = [];
      this.availableSizes = [];
      this.adocaoData = null;
      this.isLoadingAdocao = false;
      this.isApplyingAdocao = false;
    },
    openGallery(product) {
      this.itemSelected = product;
      this.$bvModal.show('modal-gallery-imagens');
    },
    uniqueEmbalagens(embalagens) {
      const seen = new Set();
      return (embalagens || []).filter((embalagem) => {
        if (!seen.has(embalagem.descricao_embalagem)) {
          seen.add(embalagem.descricao_embalagem);
          return true;
        }
        return false;
      });
    },
    getFilteredItems(itemId) {
      const target = this.normalizarSkuId(itemId);
      return this.items.filter((item) => this.normalizarSkuId(item.item_id || item.itemId) === target);
    },
    showMoreProducts() {
      this.visibleCount += 3;

      if (this.json.length <= this.visibleCount && this.hasMoreProductsToLoad) {
        this.$store.dispatch('intensPedido/loadMoreItems');
      }
    },
    showLessProducts() {
      this.visibleCount = 3;
    },
    // "+"/"−" direto no chip do item já adicionado — evita ter que excluir e
    // adicionar de novo só para mudar a quantidade.
    async alterarQtdChip(item, delta) {
      if (this.calculationLineId !== null) return;
      const idx = this.items.findIndex((i) => i.uniqueId === item.uniqueId);
      if (idx === -1) return;
      // Passo respeita o múltiplo do item (mesma regra do Adicionar)
      const passo = parseInt(this.items[idx].itemMultiplo, 10) || 1;
      const atual = parseInt(this.items[idx].valor, 10) || 1;
      const nova = atual + (delta * passo);
      if (nova < 1) return; // para remover use o X
      // Aumento respeita exatamente a mesma elegibilidade do Adicionar:
      // cliente/backorder e tenant sem bloqueio não recebem teto local.
      if (delta > 0) {
        const itemId = this.normalizarSkuId(
          this.items[idx].item_id || this.items[idx].itemId || item.item_id,
        );
        if (!await this.validarQuantidadeEstoque(itemId, nova)) return;
      }
      let atualizado = { ...this.items[idx], valor: nova };
      if (this.beforeAddItem) {
        this.calculationLineId = item.uniqueId;
        try {
          atualizado = await this.beforeAddItem(atualizado);
        } finally {
          this.calculationLineId = null;
        }
        if (!atualizado) return;
      }
      this.$set(this.items, idx, atualizado);
      // O pai (updatedGradeItens) processa apenas o ÚLTIMO elemento do array —
      // emite com o item alterado no final para atualizar a linha certa.
      const ordenado = this.items.filter((i) => i.uniqueId !== this.items[idx].uniqueId)
        .concat([this.items[idx]]);
      this.$emit('update:grade', ordenado);
    },
    removeItem(index, item) {
      const idx = this.items.findIndex((i) => i.uniqueId === item.uniqueId);
      if (idx !== -1) {
        this.items.splice(idx, 1);
        this.$emit('update:grade', this.items);
        this.$emit('remove-item', item);
      }
    },
    getAvailableSizes(color) {
      const sizes = [];
      if (this.normalizarSkuId(color.itemExtrapq)) sizes.push('Extrapq');
      if (this.normalizarSkuId(color.itemPequeno)) sizes.push('Pequeno');
      if (this.normalizarSkuId(color.itemMedio)) sizes.push('Medio');
      if (this.normalizarSkuId(color.itemGrande)) sizes.push('Grande');
      if (this.normalizarSkuId(color.itemExtraGd)) sizes.push('ExtraGd');
      if (this.normalizarSkuId(color.itemSuperGd)) sizes.push('SuperGd');
      if (this.normalizarSkuId(color.itemUltraGd)) sizes.push('UltraGd');
      if (this.normalizarSkuId(color.itemUnico)) sizes.push('Unico');
      if (this.normalizarSkuId(color.itemOutros)) sizes.push('Outros');
      return sizes;
    },
    selectEmbalagem(embalagem) {
      this.formColor.embalagem = embalagem.descricao_embalagem;
      this.formColor.cdn_embalagem = embalagem.cdn_embalagem;

      if (embalagem.grade?.dsHBIgrade?.ttHBIgrade) {
        this.availableColors = embalagem.grade.dsHBIgrade.ttHBIgrade.map((item) => ({
          cdnCor: item.cdnCor,
          desCor: item.desCor,
          itemExtrapq: item.itemExtrapq,
          itemPequeno: item.itemPequeno,
          itemMedio: item.itemMedio,
          itemGrande: item.itemGrande,
          itemExtraGd: item.itemExtraGd,
          itemSuperGd: item.itemSuperGd,
          itemUltraGd: item.itemUltraGd,
          itemUnico: item.itemUnico,
          itemOutros: item.itemOutros,
        }));

        this.availableSizes = [];
        this.showColorSizeOptions = true;
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Cores não encontradas para esta embalagem',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });

        this.availableColors = [];
        this.availableSizes = [];
        this.showColorSizeOptions = false;

        this.formColor.color = '';
        this.formColor.tamanho = '';
        this.formColor.quantidade = 0;
      }
    },
    selectColor(color) {
      const gradeColor = this.availableColors.find((item) => item.cdnCor === color.cdnCor);

      if (gradeColor) {
        this.formColor.color = gradeColor.desCor;
        this.formColor.tamanho = '';
        this.formColor.quantidade = 0;
        this.availableSizes = this.getAvailableSizes(gradeColor);
      }
    },
    async repeateAgain() {
      // Fluxo "somente quantidade": embalagem/cor/tamanho sao preenchidos
      // automaticamente por autoSelecionarVariacao(). Aqui validamos primeiro a
      // quantidade (unico campo visivel) e, so por seguranca, a variacao (caso a
      // auto-selecao tenha falhado por ausencia de grade/embalagem).
      if (!this.formColor.quantidade || Number(this.formColor.quantidade) <= 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Informe a quantidade.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      if (!this.itemSelected) {
        console.error('Nenhum item selecionado');
        return;
      }

      // Embalagem e OPCIONAL: produtos de SKU único (ex.: livros) podem não ter
      // embalagem — a home nem usa embalagem/cor/tamanho, só o item_id.
      const embalagem = (this.itemSelected.embalagens || []).find((item) => item.descricao_embalagem === this.formColor.embalagem)
        || (this.itemSelected.embalagens || [])[0]
        || null;

      if (embalagem && embalagem.itemMultiplo && embalagem.itemMultiplo !== 0) {
        const quantidade = parseInt(this.formColor.quantidade, 10);
        if (quantidade % embalagem.itemMultiplo !== 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção!',
            text: `A quantidade deste item deve ser um múltiplo de ${embalagem.itemMultiplo}!`,
          });
          return;
        }
      }

      // Resolve o SKU (item_id).  A linha já represents one exact SKU, so
      // prefer that id when the grade contains it instead of silently picking
      // the first sibling color/size.
      const exactSku = this.skuResolvidoDe(this.itemSelected);
      const gradeSkuKeys = [
        'itemExtrapq', 'itemPequeno', 'itemMedio', 'itemGrande',
        'itemExtraGd', 'itemSuperGd', 'itemUltraGd', 'itemUnico', 'itemOutros',
      ];
      let colorSel = this.formColor.color
        ? this.availableColors.find((item) => item.desCor === this.formColor.color)
        : null;
      if (exactSku && this.availableColors.length) {
        const exactColor = this.availableColors.find((color) => gradeSkuKeys
          .some((key) => this.normalizarSkuId(color[key]) === exactSku));
        if (exactColor) {
          colorSel = exactColor;
          const exactSize = this.findTamanhoByItemId(exactColor, exactSku);
          this.formColor.color = exactColor.desCor;
          if (exactSize) this.formColor.tamanho = exactSize;
        }
      }
      const gradeItemId = this.normalizarSkuId(
        (colorSel && this.formColor.tamanho)
          ? colorSel[`item${this.formColor.tamanho}`]
          : null,
      );
      const possuiGradeComSku = this.availableColors.some((color) => (
        gradeSkuKeys.some((key) => !!this.normalizarSkuId(color[key]))
      ));

      let itemId;
      let cdnCor;
      let desCor;
      let tamanhoLabel;

      if (possuiGradeComSku && (gradeItemId || exactSku)) {
        itemId = exactSku || gradeItemId;
        cdnCor = colorSel?.cdnCor ?? this.itemSelected.cdnCorUnico ?? 0;
        desCor = this.formColor.color || this.itemSelected.desCorUnico || '';
        tamanhoLabel = this.formColor.tamanho || this.itemSelected.desTamanhoUnico || 'Unico';
      } else if (!possuiGradeComSku) {
        itemId = exactSku;
        cdnCor = this.itemSelected.cdnCorUnico != null
          ? this.itemSelected.cdnCorUnico
          : (colorSel ? colorSel.cdnCor : 0);
        desCor = this.itemSelected.desCorUnico
          || (colorSel ? this.formColor.color : '');
        tamanhoLabel = this.itemSelected.desTamanhoUnico || 'Unico';
      }

      if (!this.normalizarSkuId(itemId)) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Nao foi possivel identificar a variacao deste produto. Tente selecionar novamente.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      // Deriva os campos de embalagem do objeto resolvido (nao apenas do
      // formColor). Pode ficar vazio para SKU único sem embalagem.
      const embalagemDesc = this.formColor.embalagem || (embalagem && embalagem.descricao_embalagem) || '';
      const embalagemCdn = this.formColor.cdn_embalagem || (embalagem && embalagem.cdn_embalagem) || '';

      const normalize = (value) => String(value ?? '').trim().toLowerCase();
      const targetItemId = normalize(itemId);

      const hasDuplicateLocal = this.items.some((item) => {
        const localItemId = normalize(item.item_id || item.itemId || item.itemid);
        return localItemId === targetItemId;
      });

      const storeItems = this.$store.getters['intensPedido/getlistarTabelaItens'] || [];

      const hasDuplicateInStore = storeItems.some((storeItem) => {
        const storeItemId = normalize(storeItem?.itemId || storeItem?.item_id || storeItem?.itemid);
        if (storeItemId === targetItemId) return true;

        const subItens = Array.isArray(storeItem?.itens) ? storeItem.itens : [];

        return subItens.some((subItem) => {
          const subItemId = normalize(subItem.itemId || subItem.item_id || subItem.itemid);
          return subItemId === targetItemId;
        });
      });

      if (hasDuplicateLocal || hasDuplicateInStore) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Item Duplicado',
            text: 'Este item já foi adicionado!',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      // Bloqueio de venda sem estoque — mesma regra da home (ModalEmbalagens):
      // preferência ligada OU perfil Representante (representante NUNCA pode
      // vender sem estoque, independente da preferência). Cliente NUNCA é
      // bloqueado: excedente vira backorder.
      const solicitado = parseInt(this.formColor.quantidade, 10) || 0;
      if (!await this.validarQuantidadeEstoque(itemId, solicitado)) return;

      if (isPerfilClienteAtivo() && !this.managesClientCategory) {
        const infoForm = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
        const tipoPedidoSelecionado = String(
          infoForm.tipoPedido?.tipopedidoid
            || infoForm.tipoPedidoCliente?.tipopedidoid
            || this.$store.getters['intensPedido/getFormData']?.dataCapaPedido?.tipopedidoid
            || '',
        ).toUpperCase();
        if (tipoPedidoSelecionado) {
          let flagsItem = null;
          try {
            const clienteidSel = infoForm.cliente?.clienteid;
            const { data: catResp } = await axios.post('items/categorias', {
              itemIds: [itemId],
              clienteid: clienteidSel,
            });
            flagsItem = catResp?.flags?.[itemId];
          } catch (e) {
            console.warn('[TelaNovaPedido] categorias do item indisponíveis:', e?.message);
          }
          if (Array.isArray(flagsItem)
            && flagsItem.length > 0
            && !flagsItem.includes(tipoPedidoSelecionado)) {
            Swal.fire({
              icon: 'info',
              title: 'Categoria diferente',
              text: `O produto "${this.itemSelected.item_name || itemId}" é da categoria ${nomeCategoria(flagsItem[0])}, `
                + `diferente da categoria deste pedido (${nomeCategoria(tipoPedidoSelecionado)}). `
                + 'Para incluí-lo, finalize este pedido e faça um novo pedido da categoria dele.',
            });
            return;
          }
        }
      }

      let newItem = {
        referencia: this.itemSelected.referencia ?? null,
        embalagem: embalagemDesc,
        cdn_embalagem: embalagemCdn,
        des_cor: desCor,
        cdn_cor: cdnCor,
        tamanho: tamanhoLabel,
        item_id: itemId,
        valor: parseInt(this.formColor.quantidade, 10),
        nome: this.itemSelected.item_descricao || this.itemSelected.itemDescricao
          || this.itemSelected.item_name || this.itemSelected.Descricao,
        item_descricao: this.itemSelected.item_descricao || this.itemSelected.itemDescricao
          || this.itemSelected.item_name || this.itemSelected.Descricao,
        itemDescricao: this.itemSelected.item_descricao || this.itemSelected.itemDescricao
          || this.itemSelected.item_name || this.itemSelected.Descricao,
        marca: this.itemSelected.item_marca,
        precoUnitario: parseFloat(this.itemSelected.item_price_base ?? this.itemSelected.item_price),
        valorTotal: +this.itemSelected.item_price * parseInt(this.formColor.quantidade, 10),
        itemMultiplo: (embalagem && embalagem.itemMultiplo) || 1,
        uniqueId: `${embalagemDesc}-${desCor}-${tamanhoLabel}-${itemId}-${Date.now()}`,
        itens: [{
          cdncor: cdnCor,
          desc_tamanho: tamanhoLabel,
          pedidoItemQuantidade: parseInt(this.formColor.quantidade, 10),
          itemMultiplo: (embalagem && embalagem.itemMultiplo) || 1,
          valorTotal: +this.itemSelected.item_price * parseInt(this.formColor.quantidade, 10),
        }],
      };

      if (this.beforeAddItem) {
        newItem = await this.beforeAddItem(newItem);
        if (!newItem) return;
      }

      try {
        this.items = this.items.filter((item) => this.normalizarSkuId(item.item_id || item.itemId)
          !== this.normalizarSkuId(itemId));

        this.items.push(newItem);
        this.$emit('update:grade', this.items.slice());
        this.formColor.quantidade = 0;
      } catch (error) {
        console.error('Erro ao adicionar item', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Erro ao adicionar item',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.formColor.quantidade = 0;
      }
    },
    // "Adicionar" da LISTAGEM SIMPLES: seleciona o produto (dispara o carregamento
    // do detalhe + auto-variação, se preciso), aguarda o SKU real ficar disponível
    // e reaproveita todo o pipeline do repeateAgain (validações de múltiplo,
    // duplicado, estoque, categoria) com a quantidade digitada na linha.
    async adicionarLinha(product) {
      if (this.adicionandoLinhaId !== null) return;
      const productId = this.skuResolvidoDe(product);
      const qtd = Number(this.qtdPorLinha[productId] ?? this.qtdPorLinha[product.item_id]);
      if (!qtd || qtd <= 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Informe a quantidade.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.adicionandoLinhaId = productId;
      try {
        // Seleciona (auto-variação + estoque). selecionarItem zera formColor.
        if (!this.itemSelected || this.skuResolvidoDe(this.itemSelected) !== productId) {
          this.selecionarItem(product);
        }

        // Aguarda o detalhe (SKU real / embalagens) carregar — o preCarregarDetalhes
        // do modal normalmente já deixou pronto, então isso costuma ser imediato.
        const atualizado = () => (this.json || []).find((p) => p
          && this.skuResolvidoDe(p) === productId) || product;
        let tentativas = 0;
        while (!atualizado()._detalheCarregado && tentativas < 25) {
          // eslint-disable-next-line no-await-in-loop
          await new Promise((r) => setTimeout(r, 400));
          tentativas += 1;
        }
        const prod = atualizado();
        if (!prod._detalheCarregado) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Falha',
              text: 'Não foi possível carregar os detalhes deste produto. Tente novamente.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }
        if (!this.produtoDisponivel(prod)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Indisponível',
              text: 'Não foi possível identificar um SKU ou uma variação disponível para este produto.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        this.itemSelected = prod;
        // Garante a auto-variação (embalagem -> cor -> tamanho) com o detalhe pronto.
        if (!this.formColor.embalagem && !this.formColor.color) {
          this.autoSelecionarVariacao(prod);
        }
        this.formColor.quantidade = qtd;
        await this.repeateAgain();
        // repeateAgain zera formColor.quantidade quando o item entrou; nas
        // validações que barram (múltiplo, duplicado, estoque) ele retorna cedo
        // e a quantidade permanece — nesse caso preserva o valor digitado.
        if (Number(this.formColor.quantidade) !== qtd) {
          this.$set(this.qtdPorLinha, productId, 1);
        }
      } finally {
        this.adicionandoLinhaId = null;
      }
    },
    selecionarItem(item) {
      this.itemSelected = item;
      this.formColor = {
        embalagem: '',
        cdn_embalagem: '',
        color: '',
        tamanho: '',
        quantidade: 0,
      };
      this.availableColors = [];
      this.availableSizes = [];
      this.adocaoData = null;
      if (!item._detalheCarregado && !item._carregandoDetalhe) {
        this.$emit('select-item', item);
      }
      // Fluxo "somente quantidade": escolhe automaticamente a primeira variacao
      // (embalagem -> cor -> tamanho). Ver comentario no template (bloco
      // EMBALAGEM/COR/TAMANHO comentado). Para reativar a escolha manual,
      // remova esta chamada e descomente aquele bloco.
      this.autoSelecionarVariacao(item);
      // Consulta o estoque do produto selecionado (TOTVS via backend) para
      // exibir o saldo e habilitar o bloqueio de venda sem estoque.
      this.carregarEstoqueSelecionado(item);
      // Adocao/temporada ocultos neste modal (alinhado a home) — nao busca
      // adocoes anteriores. Para reativar, restaure `this.fetchAdocoes(item)`.
    },
    // Resolve o código TOTVS (ISBN) do produto para consulta de estoque.
    // The row already carries the exact SKU; family metadata is never used as
    // a stock key.
    estoqueIdDe(product) {
      return this.skuResolvidoDe(product);
    },
    estoqueInfoDe(product) {
      const id = this.estoqueIdDe(product);
      return (id && this.estoqueMap[id]) || null;
    },
    temEstoqueInfo(product) {
      const info = this.estoqueInfoDe(product);
      // Enquanto a consulta em lote está em andamento, mantém o fallback
      // ("Em estoque") em vez de exibir "Sem info" transitório.
      return !!info && info.fonte !== 'carregando';
    },
    estoqueLabel(product) {
      return SLSEstoqueService.formatarEstoque(this.estoqueInfoDe(product));
    },
    // Consulta o estoque de todos os produtos da lista com detalhe carregado
    // (SKU real disponível) que ainda não têm saldo no estoqueMap. Uma única
    // chamada em lote — o service cacheia na sessão, então re-execuções do
    // watcher são baratas.
    async carregarEstoqueLista() {
      if (!this.controleEstoqueAtivo) return;
      const ids = [...new Set(
        (this.json || [])
          .filter((p) => p && p._detalheCarregado)
          .map((p) => this.estoqueIdDe(p))
          .filter((id) => id && !(id in this.estoqueMap)),
      )];
      if (!ids.length) return;
      // Reserva as chaves para evitar consultas duplicadas em watchers concorrentes.
      ids.forEach((id) => this.$set(this.estoqueMap, id, { quantidade: null, fonte: 'carregando' }));
      try {
        const res = await new SLSEstoqueService().consultarEstoque(ids);
        ids.forEach((id) => {
          this.$set(this.estoqueMap, id, (res && res[id]) || { quantidade: null, fonte: 'sem-resposta' });
        });
      } catch (e) {
        console.warn('[TelaNovaPedido] Falha ao consultar estoque da lista:', e);
        ids.forEach((id) => this.$set(this.estoqueMap, id, { quantidade: null, fonte: 'erro' }));
      }
    },
    async carregarEstoqueSelecionado(product, attempt = 0) {
      if (!this.controleEstoqueAtivo) return;
      const id = this.estoqueIdDe(product);
      if (!id) {
        // Detalhe (SKU real) ainda carregando -> reagenda com retry curto,
        // igual ao autoSelecionarVariacao.
        if (attempt < 15 && this.itemSelected
          && this.skuResolvidoDe(this.itemSelected) === this.skuResolvidoDe(product)) {
          setTimeout(() => {
            const atual = (this.json || []).find((p) => p
              && this.skuResolvidoDe(p) === this.skuResolvidoDe(product)) || product;
            this.carregarEstoqueSelecionado(atual, attempt + 1);
          }, 400);
        }
        return;
      }
      const existente = this.estoqueMap[id];
      if (existente && existente.quantidade !== null && existente.quantidade !== undefined) return;
      try {
        const res = await new SLSEstoqueService().consultarEstoque([id]);
        this.$set(this.estoqueMap, id, (res && res[id]) || { quantidade: null, fonte: 'sem-resposta' });
      } catch (e) {
        console.warn('[TelaNovaPedido] Falha ao consultar estoque:', e);
        this.$set(this.estoqueMap, id, { quantidade: null, fonte: 'erro' });
      }
    },
    // Seleciona automaticamente a PRIMEIRA embalagem -> primeira cor -> primeiro
    // tamanho disponiveis para o produto, deixando apenas a quantidade a cargo
    // do usuario. Reagenda com retry curto caso o detalhe (grade/embalagens)
    // ainda esteja carregando no momento do clique.
    autoSelecionarVariacao(product) {
      const productSku = product?.item_id || product?.itemId || product?.CodItem;
      const selectedSku = this.itemSelected?.item_id || this.itemSelected?.itemId
        || this.itemSelected?.CodItem;
      if (!this.itemSelected || selectedSku !== productSku) return;
      const embalagens = this.uniqueEmbalagens(this.getValidEmbalagens(product.embalagens || []));
      if (!embalagens.length) {
        // Packaging is optional.  Preserve the SKU/color/size metadata from
        // the result row instead of waiting forever for a family packaging.
        this.formColor.embalagem = product.desEmbalagemUnico || '';
        this.formColor.cdn_embalagem = product.cdnEmbalagemUnico || '';
        this.formColor.color = product.desCorUnico || '';
        this.formColor.tamanho = product.desTamanhoUnico || '';
        this.availableColors = [];
        this.availableSizes = [];
        return;
      }
      const embalagem = embalagens[0];
      const temGrade = !!(embalagem
        && embalagem.grade
        && embalagem.grade.dsHBIgrade
        && Array.isArray(embalagem.grade.dsHBIgrade.ttHBIgrade)
        && embalagem.grade.dsHBIgrade.ttHBIgrade.length);

      if (temGrade) {
        // Produto com grade de cor/tamanho: escolhe o primeiro PAR realmente
        // vendável. Algumas grades trazem cores iniciais sem qualquer item_id.
        this.selectEmbalagem(embalagem);
        const exactColor = this.availableColors.find((color) => (
          ['itemExtrapq', 'itemPequeno', 'itemMedio', 'itemGrande', 'itemExtraGd',
            'itemSuperGd', 'itemUltraGd', 'itemUnico', 'itemOutros']
            .some((key) => this.normalizarSkuId(color[key]) === this.normalizarSkuId(productSku))
        ));
        const primeiraCorComSku = exactColor || this.availableColors.find(
          (color) => this.getAvailableSizes(color).length > 0,
        );
        if (primeiraCorComSku) {
          this.selectColor(primeiraCorComSku);
          const exactSize = this.findTamanhoByItemId(primeiraCorComSku, productSku);
          if (exactSize) this.formColor.tamanho = exactSize;
          else if (this.availableSizes.length) this.formColor.tamanho = this.availableSizes[0];
        }
      } else {
        // Produto de SKU único (ex.: livro) — sem cor/tamanho. Define apenas a
        // embalagem; the exact item_id remains the selected row SKU.
        // Nao chamamos selectEmbalagem() aqui porque ele exibiria o toast
        // "Cores nao encontradas" quando nao ha grade.
        this.formColor.embalagem = embalagem.descricao_embalagem || product.desEmbalagemUnico || '';
        this.formColor.cdn_embalagem = embalagem.cdn_embalagem || product.cdnEmbalagemUnico || '';
        this.formColor.color = product.desCorUnico || '';
        this.formColor.tamanho = product.desTamanhoUnico || '';
        this.availableColors = [];
        this.availableSizes = [];
      }
    },
    async fetchAdocoes(product) {
      const formData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'] || {};
      const clienteid = formData?.cliente?.clienteid || '';
      if (!clienteid || !product?.referencia) return;

      this.isLoadingAdocao = true;
      try {
        const client = new SLSAdocaoClient();
        const canalvendaid = formData?.canalVenda?.canal_venda_id || null;
        const response = await client.getAdocoesAnteriores(
          clienteid, product.referencia, canalvendaid, this.temporadaSelecionada || null,
        );
        this.adocaoData = response.data || null;
        this.maybeAutoAplicar(product);
      } catch (err) {
        console.warn('[TelaNovaPedido] Erro ao buscar adoções anteriores:', err);
        this.adocaoData = { sugestoes: [], pedidoReferencia: null };
      } finally {
        this.isLoadingAdocao = false;
      }
    },
    maybeAutoAplicar(product) {
      if (!this.autoAplicarAdocao) return;
      if (!this.adocaoData || !this.adocaoData.sugestoes || this.adocaoData.sugestoes.length === 0) return;
      const key = `${product?.referencia}::${this.adocaoData?.pedidoReferencia?.pedidoid}::${this.temporadaSelecionada || ''}`;
      if (this.adocaoAutoAppliedTry === key) return;
      this.adocaoAutoAppliedTry = key;

      const tentar = (attempt = 0) => {
        const embalagens = this.getValidEmbalagens(product.embalagens) || [];
        const gradeReady = embalagens.some((e) => e?.grade?.dsHBIgrade?.ttHBIgrade);
        if (gradeReady) {
          const before = this.items.length;
          this.applyAdocao(product);
          if (this.items.length > before) {
            this.adocaoAutoAppliedKey = key;
          } else if (attempt < 3) {
            setTimeout(() => tentar(attempt + 1), 600);
          }
        } else if (attempt < 5) {
          setTimeout(() => tentar(attempt + 1), 500);
        }
      };
      this.$nextTick(() => tentar());
    },
    onAutoAplicarChange(product) {
      try { localStorage.setItem('carrinhoInteligente.autoAplicar', this.autoAplicarAdocao ? '1' : '0'); } catch (e) {}
      if (this.autoAplicarAdocao) this.maybeAutoAplicar(product);
    },
    onTemporadaChange(product) {
      try { localStorage.setItem('carrinhoInteligente.temporada', this.temporadaSelecionada || ''); } catch (e) {}
      this.adocaoAutoAppliedKey = null;
      this.adocaoAutoAppliedTry = null;
      this.adocaoData = null;
      if (product) this.fetchAdocoes(product);
    },
    findTamanhoByItemId(color, targetItemId) {
      const keys = ['Extrapq', 'Pequeno', 'Medio', 'Grande', 'ExtraGd', 'SuperGd', 'UltraGd', 'Unico', 'Outros'];
      const normalId = String(targetItemId || '').trim().toLowerCase();
      for (const key of keys) {
        const val = color[`item${key}`];
        if (val && String(val).trim().toLowerCase() === normalId) return key;
      }
      return null;
    },
    applyAdocao(product) {
      if (!this.adocaoData?.sugestoes?.length) return;

      this.isApplyingAdocao = true;
      const embalagens = this.getValidEmbalagens(product.embalagens);
      let applied = 0;
      let skipped = 0;

      for (const sugestao of this.adocaoData.sugestoes) {
        let found = false;

        for (const embalagem of embalagens) {
          const grade = embalagem.grade?.dsHBIgrade?.ttHBIgrade;
          if (!grade) continue;

          for (const colorEntry of grade) {
            if (Number(colorEntry.cdnCor) !== Number(sugestao.cdn_cor)) continue;

            const tamanhoKey = this.findTamanhoByItemId(colorEntry, sugestao.item_id);
            if (!tamanhoKey) continue;

            const targetId = String(sugestao.item_id || '').trim().toLowerCase();
            const hasDup = this.items.some(
              (i) => String(i.item_id || '').trim().toLowerCase() === targetId,
            );
            if (hasDup) {
              found = true;
              skipped++;
              break;
            }

            let qty = parseInt(sugestao.quantidade, 10) || 1;
            if (embalagem.itemMultiplo && embalagem.itemMultiplo !== 0) {
              qty = Math.ceil(qty / embalagem.itemMultiplo) * embalagem.itemMultiplo;
            }

            const newItem = {
              referencia: product.referencia,
              embalagem: embalagem.descricao_embalagem,
              cdn_embalagem: embalagem.cdn_embalagem,
              des_cor: colorEntry.desCor,
              cdn_cor: colorEntry.cdnCor,
              tamanho: tamanhoKey,
              item_id: sugestao.item_id,
              valor: qty,
              nome: product.item_name,
              marca: product.item_marca,
              precoUnitario: parseFloat(product.item_price_base ?? product.item_price),
              valorTotal: +product.item_price * qty,
              itemMultiplo: embalagem.itemMultiplo || 1,
              uniqueId: `adocao-${embalagem.cdn_embalagem}-${colorEntry.cdnCor}-${tamanhoKey}-${sugestao.item_id}-${Date.now()}`,
              itens: [{
                cdncor: colorEntry.cdnCor,
                desc_tamanho: tamanhoKey,
                pedidoItemQuantidade: qty,
                itemMultiplo: embalagem.itemMultiplo || 1,
                valorTotal: +product.item_price * qty,
              }],
            };

            this.items.push(newItem);
            applied++;
            found = true;
            break;
          }
          if (found) break;
        }
        if (!found) skipped++;
      }

      this.$emit('update:grade', this.items.slice());
      this.isApplyingAdocao = false;

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Carrinho Inteligente',
          text: applied > 0
            ? `${applied} item(s) aplicado(s) com sucesso!${skipped > 0 ? ` (${skipped} já existente(s) ignorado(s))` : ''}`
            : 'Nenhum item pôde ser aplicado (embalagem/grade não carregada ainda).',
          icon: 'ShoppingCartIcon',
          variant: applied > 0 ? 'success' : 'warning',
        },
      });
    },
  },
};
</script>
<style scoped>
.imagens-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.imagens-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}

.imagens-item-img {
  border: 1px solid var(--primary);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.imagens-item-img img {
  height: 50px;
  width: auto;
  object-fit: contain;
}

.loading-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: center;
}

.product-color-options h6 {
  font-size: 16px;
  font-weight: 600;
}

/* ===== Listagem simples em linhas ===== */
.lista-itens-simples {
  display: flex;
  flex-direction: column;
}

.linha-item {
  padding: 8px 6px;
  border-bottom: 1px solid rgba(34, 41, 47, 0.08);
  gap: 4px;
}

.linha-thumb {
  width: 52px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 4px;
  background: rgba(34, 41, 47, 0.03);
}

.linha-thumb img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.linha-nome {
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.25;
}

.linha-meta {
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
}

.linha-preco {
  font-weight: 600;
  color: var(--primary);
}

.linha-qtd {
  width: 82px;
}

/* Controle de quantidade do item já adicionado (− | qtd | + | remover) */
.qtd-control {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border: 1px solid rgba(115, 103, 240, 0.35);
  border-radius: 8px;
  background: rgba(115, 103, 240, 0.06);
}

.qtd-control-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--primary);
  margin-right: 2px;
}

.qtd-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  padding: 0;
  transition: background 0.15s ease;
}

.qtd-btn-menos {
  border: 1.5px solid #ea5455;
  color: #ea5455;
}
.qtd-btn-menos:hover {
  background: rgba(234, 84, 85, 0.12);
}

.qtd-btn-mais {
  border: 1.5px solid #28c76f;
  color: #28c76f;
}
.qtd-btn-mais:hover {
  background: rgba(40, 199, 111, 0.12);
}

.qtd-btn-remover {
  border: 1.5px solid rgba(110, 107, 123, 0.5);
  color: #6e6b7b;
  margin-left: 2px;
}
.qtd-btn-remover:hover {
  background: rgba(234, 84, 85, 0.12);
  border-color: #ea5455;
  color: #ea5455;
}

.qtd-valor {
  min-width: 38px;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 6px;
  background: #2f2b3d;
  color: #fff;
}

@media (max-width: 576px) {
  .linha-item {
    flex-wrap: wrap;
  }
  .linha-acao {
    width: 100%;
    margin-top: 6px;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .imagens-container {
    width: 100%;
    padding-bottom: 10px;
    flex-direction: row;
    justify-content: center;
  }

  .imagens-item {
    flex-direction: row;
  }

  /* Mantém rolagem horizontal para listas com muitas opções */
  .product-color-options .scrollable-pills {
    flex-direction: row;
    flex-wrap: nowrap;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .product-color-options ul li {
    width: 100%;
    text-align: center;
  }

  .product-color-options h6 {
    text-align: center;
  }

  .ecommerce-details-item_price {
    justify-content: center;
  }

  .item-item_price {
    text-align: center;
    width: 100%;
  }

  .col-md-6 {
    text-align: center;
  }

  .app-ecommerce-details .row.ml-1 {
    margin-left: 0 !important;
  }

  .imagens-container {
    flex-direction: row !important;
    justify-content: center;
    width: 100%;
  }

  .imagens-container.col-1 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

/* Scroll horizontal suave para pílulas (desktop e mobile) */
.scrollable-pills {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 6px;
  scroll-snap-type: x proximity;
}
.scrollable-pills li {
  flex: 0 0 auto;
  scroll-snap-align: start;
}
.scrollable-pills::-webkit-scrollbar {
  height: 6px;
}
.scrollable-pills::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.2);
  border-radius: 3px;
}
</style>
